<template>
	<div class="home">
		<div v-if="chargingLinkLoading" class="display-message">
			<img src="/static/logo-horiz.png" alt="">
			<b>Carregando Cobrança</b>
		</div>
		<charging v-else :sale="sale" :chargingLink="chargingLink"/>
	</div>
</template>

<script>
import Charging from './Charging.vue';
import Multiselect from 'vue-multiselect';
import PaymentWebservice from '../../services/PaymentWebservice';
import Sale from '../../models/Sale';
import * as uuid from 'uuid';
import BlumarConfig from '../../blumar-config';

function isValidUUID(uuid) {
	return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);
}

export default {
	components: { Charging, Multiselect },
	data() {
		return {
			paymentWebservice: new PaymentWebservice(),
			sale: null,
			chargingLink: null,
      fingerPrintId: uuid.v4(),
		};
	},
	computed: {
		chargingLinkLoading() {
			return !this.chargingLink || !this.sale;
		}
	},
	mounted() {
		this.fetchChargingLink();
	},
	methods: {
		async fetchChargingLink() {
			let chargingLinkCode = this.$route.params.id;
			try {
				if (!isValidUUID(chargingLinkCode))
					this.$router.push({name: 'page-not-found'});

				let response = await this.paymentWebservice.getChargingLink(chargingLinkCode);
				this.chargingLink = response.data;
				this.sale = Sale.fromChargingLink(this.chargingLink);

        if (this.chargingLink.useFraudAnalysis) {
          this.sale = this.sale.withFraudAnalysis(this.fingerPrintId);
					this.installFingerPrint();
				}

			} catch (error) {
				console.log(error);
				if (error.response.status === 400)
          this.sendToFeedbackPage(error.response.data.message);
				else
					this.$router.push({name: 'page-not-found'});
			}
		},
    sendToFeedbackPage(message) {
      console.log('sendToFeedbackPage', message);
      this.$router.push({
        name: 'charging-feedback',
        params: {
          message,
          sale: this.sale
        }
      });
    },
		removeFingerPrint() {
			let script = document.getElementById("finger-print-script");
			if (script) document.body.removeChild(script);
      let iframe = document.getElementById("finger-print-iframe");
			if (iframe) document.body.removeChild(iframe);
		},
		installFingerPrint() {
			console.log("ChargingLink", this.chargingLink);
      let antifraudOrgId = BlumarConfig.antifraudOrgId;
			console.log("antifraudOrgId", antifraudOrgId);
      let sessionId = this.chargingLink.company.antifraudId + this.fingerPrintId;
			console.log("companyAntifraudId", this.chargingLink.company.antifraudId);
			console.log("fingerPrintId", this.fingerPrintId);
			console.log("sessionId", sessionId);

			this.removeFingerPrint();

      document.body.appendChild(script());
      document.body.appendChild(iframe());

      function iframe() {
        let iframe = document.createElement("iframe");
        iframe.setAttribute("style", "width:100px; heigth:100px; border:0; position:absolute; top:-5000-px;");
        iframe.setAttribute("src", `https://h.online-metrix.net/fp/tags.js?org_id=${antifraudOrgId}&session_id=${sessionId}`);

        let noscript = document.createElement("noscript");
        noscript.id = "finger-print-iframe";
        noscript.appendChild(iframe);
        return noscript;
      }

      function script() {
        let script = document.createElement("script");
        script.id = "finger-print-script";
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", `https://h.online-metrix.net/fp/tags.js?org_id=${antifraudOrgId}&session_id=${sessionId}`);
        return script;
      }

		},
	}
}
</script>

<style scoped lang="scss">
.home {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 50px;
}

.display-message {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 700px;
	height: 500px;
	background: white;
	border-radius: 20px;
	img {
		height: 100px;
		margin-bottom: 100px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue